/**
 * Nhãn thay số đơn bán hàng / PI / phiếu giao ở các khâu SAU chuỗi bán hàng (MRP, sản xuất, giữ hàng, nhập kho, đơn mua, xuất
 * bán…) khi người xem không được thấy khách đứng sau chứng từ đó (YC-01, 07/10/2026).
 *
 * Mở rộng phương án A khách chọn cho PI "chỉ quản trị viên": khâu sau VẪN tính, vẫn làm việc với chứng từ đó, chỉ không biết cho
 * ai — "kho cần biết phải chuẩn bị bao nhiêu hàng, không cần biết cho ai". Giá trị giữ nguyên chuỗi cũ của MRP để bản chụp,
 * bài kiểm và giao diện đang dùng không phải đổi. Giao diện dịch bằng khoá `common.internalReference`.
 */
export const INTERNAL_REFERENCE = "internal_demand";

export function isInternalReference(label: string | null | undefined): boolean {
  return label === INTERNAL_REFERENCE;
}
